import * as React from 'react';
export const webflowSvg = React.forwardRef(function webflowSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'm27.89 8.296-6.984 14.409h-6.561l2.923-5.972h-.131C14.725 20.036 11.127 22.21 6 22.704v-5.889s3.28-.204 5.208-2.343H6V8.296h5.853v5.08l.132-.001 2.391-5.08h4.427v5.048h.131l2.482-5.047h6.475Z',
      clipRule: 'evenodd',
    }),
  );
});
webflowSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var webflow = {
  category: 'brand',
  colorable: false,
  name: 'webflow',
  svg: webflowSvg,
};
